import React from 'react'
import { Header } from '../views/includes/header'
import { Footer } from '../views/includes/footer'
import { Scrolltop } from '../views/includes/components/scrollTop'

const Main = ({ children }) => {

    console.log('render Main')

    return (
        <>
            <div>
                <Header />
                {children}
                <Scrolltop />
                <Footer />
            </div>
        </>
    )
}

export default Main;

